<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <button :class="classes" @click="handleClick">
    <div
      v-if="props.type === 'primary'"
      class="absolute -inset-1 bg-orange transform -translate-x-full group-hover:translate-x-0 linkTransition"
    />
    <div class="relative z-2">{{ label }}</div>
  </button>
</template>

<script lang="ts" setup>
import { computed } from "vue";

export interface ButtonProps {
  label: string;
  classes?: string;
  theme: "dark" | "light";
  type?: "primary" | "secondary";
  isUmbraco?: boolean;
}

const props = withDefaults(defineProps<ButtonProps>(), {
  isActive: false,
  theme: "light",
  type: "primary",
  isUmbraco: false,
});

type Emits = {
  (e: "handleClick"): void;
};
const emit = defineEmits<Emits>();

const handleClick = () => {
  emit("handleClick");
  console.log("Button clicked");  
};

const colorPrimay = computed(() => {
  if (!props.isUmbraco) return `bg-btn-bg text-btn-text hover:text-white`;
  return props.theme === "light"
    ? "bg-aubergine text-white hover:text-white"
    : "bg-white text-aubergine hover:text-white";
});

const colorSecondary = computed(() => {
  return props.theme === "light"
    ? "text-aubergine border-aubergine"
    : "text-white border-white";
});

const classes = computed(() => {
  const buttonTypeStyles =
    props.type === "primary"
      ? `overflow-hidden px-8 py-[13px] ${colorPrimay.value}`
      : `border-b-4 ${colorSecondary.value} hover:border-orange pb-[6px]`;

  return `inline-block group relative text-button font-bold ${buttonTypeStyles} ${props.classes} linkTransition`;
});
</script>
